export const environment = {
  production: false,
  API_URL: 'https://testapi.incust.com/v1/client',
  API_BUSINESS_URL: 'https://testapi.incust.com/v1',
  CLIENT_URL: 'https://testclient.incust.com',
  SELF_URL: 'https://testpreview.incust.com'
};
